import { createMuiTheme } from "@material-ui/core/styles"

let theme = createMuiTheme()

const palette = {
  primary: {
    main: "#001F54",
    light: "#2FBBF0",
    dark: "#000000DE",
    default: "#001F54"
  },
  secondary: {
    main: "#FF0000",
    light: "#fff",
    dark: "#000"
  },
  alt: {
    main: "#78A1BB"
  },
  warning: {
    main: "#FF0000",
    light: "#FFF",
    dark: "#000"
  }
}

const typography = {
  fontFamily: ["Poppins", "sans-serif"].join(",")
}

const spacing = 8

const breakpoints = {
  values: {
    xs: 0,
    sm: 540,
    md: 720,
    lg: 1280,
    xl: 1920
  }
}

theme = createMuiTheme({
  palette,
  typography,
  breakpoints,
  spacing: spacing,
  overrides: {
    MuiContainer: {
      root: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100% - 120px)",
        width: "100%",
        paddingTop: 40,
        paddingBottom: 75,
        paddingLeft: 40,
        paddingRight: 40,
        [theme.breakpoints.down("sm")]: {
          paddingTop: 20,
          paddingBottom: 100,
          paddingLeft: 20,
          paddingRight: 20
        }
      }
    },
    MuiTypography: {
      colorSecondary: {
        color: palette.alt.main
      },
      body1: {
        fontSize: 12
      },
      body2: {
        fontSize: 20
      },
      h2: {
        marginBottom: 12,
        fontFamily: "'Poppins', 'sans-serif'",
        fontSize: 32,
        fontWeight: 700
      },
      h3: {
        marginBottom: 12,
        fontFamily: "'Poppins', 'sans-serif'",
        fontSize: 26,
        fontWeight: 700,
        textTransform: "uppercase"
      },
      h4: {
        fontSize: 24,
        fontWeight: "bold",
        fontFamily: "'Poppins', 'sans-serif'"
      },
      h5: {
        fontFamily: "'Poppins', 'sans-serif'",
        fontSize: 20,
        fontWeight: "bold"
      },
      h6: {
        fontFamily: "'Poppins', 'sans-serif'",
        fontSize: 16,
        fontWeight: "bold"
      },

      subtitle1: {
        fontSize: 14,
        fontFamily: "'Poppins', 'sans-serif'"
      },
      subtitle2: {
        fontSize: 17,
        fontFamily: "'Poppins', 'sans-serif'"
      }
    },
    MuiFormControl: {
      root: {
        margin: `${theme.spacing(2)}px 0`,
        width: "100%"
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: "20px",
        fontWeight: "bold",
        fontFamily: "'Poppins', 'sans-serif'"
      }
    },
    MuiInput: {
      input: {
        fontSize: "1rem",
        color: palette.primary.default,
        "&::placeholder": {
          color: "rgba(0, 0, 0, 0.45)",
          opacity: [1, "!important"]
        }
      },
      underline: {
        "&:after": {
          borderBottomColor: palette.primary.light
        }
      }
    },
    MuiFormHelperText: {
      root: {
        position: "absolute",
        bottom: -18
      }
    },
    MuiBottomNavigationAction: {
      root: {
        minWidth: 60,
        paddingBottom: 0
      },
      iconOnly: {
        paddingTop: [0, "!important"]
      }
    },
    MuiButton: {
      root: {
        fontFamily: "Roboto",
        textTransform: ["capitalize", "!important"],
        color: "white"
      },

      containedPrimary: {
        backgroundColor: palette.primary.light,
        "&:hover": {
          backgroundColor: palette.primary.light
        }
      },
      containedSecondary: {
        backgroundColor: palette.secondary.light,
        color: palette.primary.dark
      }
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: 1000
      }
    },
    MuiPickersModal: {
      dialog: {
        "& .MuiIconButton-label": {
          color: "#d1d1d1"
        },
        "& .MuiTypography-body1": {
          color: palette.primary.main
        },
        "& .MuiPickersDay-dayDisabled .MuiTypography-body2": {
          color: "#d1d1d1"
        },
        "& .MuiTypography-body2": {
          color: palette.primary.main
        },
        "& .MuiPickersDay-daySelected .MuiTypography-body2": {
          color: "#fff"
        },
        "& .MuiPickersDay-day .MuiIconButton-label": {
          color: "#d1d1d1"
        },
        "& + div > button": {
          color: `${palette.primary.main} !important`
        },
        "& + div > button.MuiPickersDay-day": {
          color: "#000"
        }
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        "& h2": {
          margin: 0
        }
      }
    },
    MuiDialogContent: {
      root: {
        flex: "unset"
      }
    },
    MuiFilledInput: {
      // root: {
      //   background: "#f1f1f1"
      // },
      input: {
        padding: "0px"
      },
      multiline: {
        padding: 0
      }
      // "&:hover": {
      //   backgroundColor: "#808080"
      // }
    },
    MuiSelect: {
      select: {
        fontWeight: 700,
        margin: "auto",
        fontSize: 14,
        textAlign: "left",
        fontFamily: "Roboto"
      }
    },
    MuiStepConnector: {
      line: {
        display: "none"
      }
    },
    MuiCardHeader: {
      title: {
        fontSize: 16,
        fontWeight: 700
      },
      subheader: {
        fontSize: 12
      }
    },
    MuiIconButton: {
      root: {
        color: "white"
      }
    },
    MuiSvgIcon: {
      colorSecondary: {
        color: palette.alt.main
      }
    },
    MuiInputBase: {
      input: {
        // marginTop: "5px",
        color: "#00000061"
      }
    },
    MuiToolbar: {
      root: {
        minHeight: [80, "!important"]
      }
    },
    MuiBadge: {
      badge: {
        backgroundColor: theme.palette.primary.light
      }
    },
    MuiLinearProgress: {
      barColorPrimary: {
        backgroundColor: "#2FBBF0"
      },
      colorPrimary: {
        backgroundColor: "#2FBBF044"
      }
    },

    // MuiTab: {
    //   [theme.breakpoints.down("md")]: {
    //     root: {
    //       minWidth: "unset+!important",
    //       maxWidth: "unset+!important"
    //     }
    //   }
    // },
    MuiTab: {
      root: {
        [theme.breakpoints.up("540")]: {
          minWidth: "unset",
          maxWidth: "unset"
        }
      }
    },
    MuiSkeleton: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.2)"
      }
    },
    MuiSlider: {
      rail: {
        height: 10,
        [theme.breakpoints.down("sm")]: {
          width: "10px!important"
        }
      },
      track: {
        backgroundColor: "none"
      },
      mark: {
        height: 10,
        color: "white",
        [theme.breakpoints.down("sm")]: {
          width: "10px!important"
        }
      },
      markLabel: {
        transform: "translateY(-250%) translateX(-30%)",
        [theme.breakpoints.down("sm")]: {
          left: "50px!important"
        }
      },

      markLabelActive: {
        fontWeight: 700
      },

      thumb: {
        width: 25,
        height: 25,
        color: palette.primary.light
      }
    },
    MuiAvatar: {
      img: {
        height: "auto"
      }
    },
    MuiSwitch: {
      colorPrimary: {
        "&$checked": {
          color: "rgb(34,139,34) !important"
        },
        "&$checked + $track": {
          backgroundColor: "rgb(34,139,34,0.8) !important"
        }
      }
    }
  }
})

export default theme



// WEBPACK FOOTER //
// ./src/themes/main.js